import React from 'react';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import './InvestorCard.scss';

export interface IInvestorCard {
    title: string;
    bodyCopy: string;
    investorImage: ImageDataLike;
    investorImageAlt: string;
}
export const InvestorCard = ({ inputs }: { inputs: IInvestorCard }) => {
    if (!inputs.title || !inputs.investorImage) return <></>;
    const { title, bodyCopy, investorImage, investorImageAlt } = inputs;
    const gImage = investorImage ? getImage(investorImage) : undefined;

    return (
        <section className="investor-card">
            <div className="investor-card__content">
                {investorImage && (
                    <GatsbyImage image={gImage} alt={investorImageAlt ?? ``} />
                )}
                <div className="text-content">
                    <h3 className={`typestack-title-3`}>{title}</h3>
                    <div
                        className={`typestack-investor-body`}
                        dangerouslySetInnerHTML={{ __html: bodyCopy }}
                    />
                </div>
            </div>
        </section>
    );
};
